// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2mIwW","info":"PatientInfo_info__13QF8"};